/**
 * help with mediaqueries and media-query dependent values
 */
(function ($) {
    var $mqHelper = $('#mq-helper');
    setMq();
    $(window).on('resize', window.BCB.throttle(function () {
        setMq();
    }, 200));
    function setMq() {
        // change value depending on mediaqueries
        switch ($mqHelper.css('z-index')) {
            case '1':
                window.BCB.mq = 1;
                window.BCB.scrollOffset = 60;
                break;
            case '2':
                window.BCB.mq = 2;
                window.BCB.scrollOffset = 70;
                break;
            case '3':
                window.BCB.mq = 3;
                window.BCB.scrollOffset = 110;
                break;
            case '4':
                window.BCB.mq = 4;
                window.BCB.scrollOffset = 130;
                break;
        }
    }
})(jQuery);
